import { APICore } from './apiCore'

const api = new APICore()

function getCertificaciones (params) {
  const baseUrl = '/certificaciones'
  return api.get(baseUrl, params)
}

function getCertificacion (id) {
  const baseUrl = `/certificaciones/${id}`
  return api.get(baseUrl, {})
}

function addCertificacion (params) {
  const baseUrl = '/certificaciones'
  return api.createWithFile(baseUrl, params)
}

function updateCertificacion (params) {
  const baseUrl = '/certificaciones'
  return api.updateWithFile(baseUrl, params)
}

function deleteCertificacion (params) {
  const baseUrl = '/certificaciones'
  return api.delete(baseUrl, params)
}

export { getCertificaciones, getCertificacion, addCertificacion, updateCertificacion, deleteCertificacion }
